import { Link } from "react-router-dom"

import variables from "@/_styles/variables.module.scss"
import { getAuthorityLogFileById } from "@/http/authorities"

import { IAuthorityLogs, LogStatusColors } from "@/types/IAuthorities"
import { ITableColumn } from "@/types/ui"

import { paths } from "@/router/paths"

import { downloadFile } from "@/utils/download"
import { dateTimeFormat, formatDate } from "@/utils/formatDate"


export const authorityLogsColumns: ITableColumn<IAuthorityLogs>[] = [
  {
    title: "Доверенность",
    key: "authorityNumber",
    dataIndex: ["authorityNumber"],
    render:  (_, { id, authorityNumber }) =>
      <Link to={paths.authoritiesById(id)}>
        {authorityNumber}
      </Link>,
    align: "center",
    width: 160,
    sorter: true,
    isVisible: true,
    order: 1
  },
  {
    title: "Дата",
    key: "dateTime",
    dataIndex: ["dateTime"],
    render: (_: any, { dateTime }) => <>{dateTime && <span>{formatDate(dateTime, dateTimeFormat)}</span>}</>,
    align: "center",
    width: 160,
    sorter: true,
    defaultSortOrder: "descend",
    isVisible: true,
    order: 2
  },
  {
    title: "Статус",
    key: "status",
    dataIndex: ["statusText"],
    align: "center",
    render: (_, { status, statusText }) => 
      <>
        <span style={{ fontWeight: 600, color: LogStatusColors[status] }}>
          {statusText}
        </span>
      </>,
    width: 120,
    sorter: true,
    isVisible: true,
    order: 3
  },
  {
    title: "Скачать файл ответа",
    key: "storageKey",
    dataIndex: ["storageKey"],
    align: "center",
    render:  (_, { id, storageKey }) =>
      <span
        style={{ padding: 19, color: variables.basecolorlight, borderColor: variables.basecolorlight }}
        onClick={async (e) => {downloadFile(await getAuthorityLogFileById(id))
          .then()
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        {storageKey ? storageKey.split("/").pop() : ""}
      </span>,
    width: 120,
    sorter: true,
    isVisible: true,
    order: 4
  }
]